import axios from 'axios';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    const params = query || {};
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'discount-package-catalogs', { params })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
